import { render, staticRenderFns } from "./Parcels.vue?vue&type=template&id=78c4d8ca&scoped=true&"
import script from "./Parcels.vue?vue&type=script&lang=js&"
export * from "./Parcels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4d8ca",
  null
  
)

export default component.exports